/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner } from './update-available-currencies200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableCurrencies200ResponseReissue } from './update-available-currencies200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableCurrencies200ResponseUser } from './update-available-currencies200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableCurrencies200ResponseUserAccountGroup } from './update-available-currencies200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateAvailableCurrencies200Response
 */
export interface UpdateAvailableCurrencies200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'availableCurrencies': Array<UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'availableMerchantCategories': Array<UpdateAvailableCurrencies200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateAvailableCurrencies200ResponseUser}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'user': UpdateAvailableCurrencies200ResponseUser;
    /**
     * 
     * @type {UpdateAvailableCurrencies200ResponseUserAccountGroup}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'userAccountGroup'?: UpdateAvailableCurrencies200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableCurrencies200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableCurrencies200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateAvailableCurrencies200ResponseReissue}
     * @memberof UpdateAvailableCurrencies200Response
     */
    'reissue'?: UpdateAvailableCurrencies200ResponseReissue | null;
}

export const UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum = typeof UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum[keyof typeof UpdateAvailableCurrencies200ResponseAvailableCurrenciesEnum];


